import { Navigate } from 'react-router';

import RouteLoadingShell from '../components/RouteLoadingShell';
import { LandingHero, hasAuthCookie } from '../features/auth';
import { pickLocalized, useLanguage } from '../features/i18n';
import { useAuth } from '../hooks/useAuth';

export default function LandingRoute() {
  const { language } = useLanguage();
  const hasCookie = hasAuthCookie();
  const { status, isPending, isError } = useAuth();

  // 임시 오류는 로그인 여부를 확정하지 않는다. 공개 랜딩을 안전하게 유지한다.
  if (isError) {
    return <LandingHero />;
  }

  if (isPending || status === 'idle') {
    // 힌트가 없는 익명 방문자에게는 blocking shell 대신 prerendered 랜딩을
    // 유지한다. 힌트는 presentation 만 바꾸며 query 실행 여부는 결정하지 않는다.
    if (!hasCookie) {
      return <LandingHero />;
    }
    return (
      <RouteLoadingShell
        route="landing"
        title={pickLocalized(language, {
          ko: '랜딩 페이지 준비 중…',
          en: 'Preparing the landing page…',
          ja: 'ランディングページを準備しています…',
        })}
        description={pickLocalized(language, {
          ko: '기존 로그인 상태를 확인하고 있습니다.',
          en: 'Checking your existing sign-in state.',
          ja: '現在のログイン状態を確認しています。',
        })}
      />
    );
  }

  if (status === 'authenticated') {
    return <Navigate to="/studio" replace />;
  }

  return <LandingHero />;
}
